import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TopbarWidget } from './components/topbarwidget.component';
import { HeroWidget } from './components/herowidget';
import { MembershipWidget } from './components/membershipwidget';
import { AboutWidget } from './components/aboutwidget';
import { HqWidget } from './components/hqwidget';
import { FooterWidget } from './components/footerwidget';
import { WhatsappWidget } from './components/whatsapp-widget.component';
import { SeoService } from './services/seo.service';

@Component({
    selector: 'app-landing',
    standalone: true,
    imports: [
        TopbarWidget,
        HeroWidget,
        MembershipWidget,
        AboutWidget,
        HqWidget,
        FooterWidget,
        WhatsappWidget
    ],
    template: `
        <div class="flex flex-column min-h-screen bg-usina-bg">
            
            <topbar-widget></topbar-widget>

            <main class="flex-grow-1 pt-2">
                
                <hero-widget></hero-widget>

                <membership-widget></membership-widget>
                <about-widget></about-widget>
                <hq-widget></hq-widget>

                <footer-widget></footer-widget>

                <whatsapp-widget></whatsapp-widget>
            </main>
            
            
        </div>
    `,
    styles: [`
        .bg-usina-bg {
            background-color: var(--usina-bg, #F2F2F2);
        }
    `]
})
export class Landing implements OnInit {
    constructor(public router: Router, private seoService: SeoService) {}

    ngOnInit(): void {
        // Meta tags para la homepage
        this.seoService.update({
            title:       'Usina Cowork | Coworking en Buenos Aires · Chacarita y San Isidro',
            description: 'Coworking en Buenos Aires con membresías flexibles, oficinas privadas, salas de reunión y auditorio. Sedes en Chacarita y San Isidro.',
            canonicalPath: '/'
        });

        // Schema.org: LocalBusiness + CoworkingSpace
        this.seoService.injectSchema({
            '@context': 'https://schema.org',
            '@graph': [
                {
                    '@type': ['LocalBusiness', 'CoworkingSpace'],
                    '@id': 'https://www.usinaco.work/#organization',
                    'name': 'Usina Cowork',
                    'url': 'https://www.usinaco.work',
                    'logo': 'https://www.usinaco.work/assets/img/logo-usina.png',
                    'image': 'https://www.usinaco.work/assets/img/og-image.jpg',
                    'description': 'Coworking en Buenos Aires con membresías flexibles, oficinas privadas, salas de reunión y auditorio en Chacarita y San Isidro.',
                    'telephone': '+5491139030084',
                    'email': 'hola@usinaco.work',
                    'address': [
                        {
                            '@type': 'PostalAddress',
                            'streetAddress': 'Castillo 1366',
                            'addressLocality': 'Chacarita',
                            'addressRegion': 'Ciudad Autónoma de Buenos Aires',
                            'addressCountry': 'AR'
                        },
                        {
                            '@type': 'PostalAddress',
                            'streetAddress': 'Av. del Libertador esquina Ituzaingó',
                            'addressLocality': 'San Isidro',
                            'addressRegion': 'Buenos Aires',
                            'addressCountry': 'AR'
                        }
                    ],
                    'openingHoursSpecification': [
                        {
                            '@type': 'OpeningHoursSpecification',
                            'dayOfWeek': ['Monday','Tuesday','Wednesday','Thursday','Friday'],
                            'opens': '09:00',
                            'closes': '21:00'
                        }
                    ],
                    'sameAs': [
                        'https://www.instagram.com/usinacowork/',
                        'https://www.linkedin.com/company/usina-cowork/',
                        'https://ar.pinterest.com/usinacowork/'
                    ],
                    'priceRange': '$$'
                }
            ]
        }, 'schema-homepage');
    }
}